import React from "react";
import { FieldLabel, StyledField } from "../styled/StyledTextField.styled";
import { FormControl } from "@mui/material";
import { FormHelperText } from "@mui/material";

export default function StyledTextField({
  label,
  placeholder,
  helperText,
  ...props
}) {
  return (
    <div style={{ marginBottom: "0px" }}>
      <FormControl variant="standard" sx={{ width: "100%" }}>
        <FieldLabel disableAnimation={true} shrink id={label}>
          {label}
        </FieldLabel>
        <StyledField
          {...props}
          helperText="Incorrect entry"
          placeholder={placeholder}
          fullWidth
          notched={false}
          style={{ marginTop: "30px" }}
        />
        <FormHelperText error>{helperText}</FormHelperText>
      </FormControl>
    </div>
  );
}
